import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApibaseService } from './apibase.service';

export interface TalkJsSession {
  appId: string;
  token: string;
}

export type TalkJsPerfil = 'operator' | 'driver';

/**
 * Consome a rota de Identity Verification do TalkJS no control-tower-api:
 *   GET controlTower/talkjs/session?perfil=operator|driver  ->  { appId, token }
 *
 * - appId: parametrizado por ambiente/projeto no backend (não mais hardcoded).
 * - token: JWT (HS256) assinado com a secret do TalkJS, usado como tokenFetcher.
 */
@Injectable({ providedIn: 'root' })
export class TalkJsApiService extends ApibaseService {

  prefixoUrl = 'controlTower';
  urlFunction = 'talkjs';

  constructor(protected http: HttpClient) {
    super(http);
  }

  getSession(perfil: TalkJsPerfil = 'operator'): Observable<TalkJsSession> {
    return super.get<TalkJsSession>({
      extraUrl: 'session',
      paramns: new HttpParams().set('perfil', perfil),
    });
  }
}
